/**
 * Moves a group of items down in an array
 * @param arr - The array to modify
 * @param indices - The indices of items to move down
 * @returns A new array with the items moved down
 */
export const moveGroupDown = <T>(arr: T[], indices: number[]): T[] => {
  const result = [...arr];

  // Sort indices in descending order to avoid index shifting
  const sortedIndices = [...indices].sort((a, b) => b - a);

  // For each index, move the item down one position
  for (const idx of sortedIndices) {
    if (idx < result.length - 1) {
      // Swap with the item below
      [result[idx], result[idx + 1]] = [result[idx + 1], result[idx]];
    }
  }

  return result;
};

/**
 * Moves a group of items up in an array
 * @param arr - The array to modify
 * @param indices - The indices of items to move up
 * @returns A new array with the items moved up
 */
export const moveGroupUp = <T>(arr: T[], indices: number[]): T[] => {
  const result = [...arr];

  // Sort indices in ascending order to avoid index shifting
  const sortedIndices = [...indices].sort((a, b) => a - b);

  // For each index, move the item up one position
  for (const idx of sortedIndices) {
    if (idx > 0) {
      // Swap with the item above
      [result[idx], result[idx - 1]] = [result[idx - 1], result[idx]];
    }
  }

  return result;
};
